import { Inject, Pipe, PipeTransform, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { BrowserService } from '../service/browser.service';

@Pipe({
  name: 'sanitizeHtml',
  standalone: true,
})
export class SanitizeHtmlPipe implements PipeTransform {
  constructor(
    private sanitizer: DomSanitizer,
     private browser: BrowserService
  ) {}

  transform(value: string): SafeHtml {
    if (!value) {
      return '';
    }

    if (!this.browser.isBrowser) {
      return this.sanitizer.bypassSecurityTrustHtml(value);
    }
    value = value
      .replace(/\\u0095/g, '•')
      .replace(/\u0095/g, '•')  
      .replace(//g, '•'); 

    const parser = new DOMParser();
    const doc = parser.parseFromString(value, 'text/html');

    doc.querySelectorAll('p[dir="ltr"]').forEach((node) => {
      const parent = node.parentNode;
      if (parent) {
        while (node.firstChild) {
          parent.insertBefore(node.firstChild, node);
        }
        parent.removeChild(node);
      }
    });

     doc.querySelectorAll('[style]').forEach((element) => {
      const style = element.getAttribute('style');

      if (style) {
        const updatedStyle = style
          .replace(/display\s*:\s*-webkit-box\s*;?/gi, '')
          .trim();

        if (updatedStyle) {
          element.setAttribute('style', updatedStyle);
        } else {
          element.removeAttribute('style');
        }
      }
    });

    return this.sanitizer.bypassSecurityTrustHtml(doc.body.innerHTML);
  }
}
